export default __webpack_public_path__ + "static/media/476.01ce22a3.gif";